import brainfuck from "refractor/brainfuck";
export default brainfuck;